export const ALERTS_FETCH_SUCCESS = 'ALERTS_FETCH_SUCCESS';
export const UPDATE_ALERT_SUCCESS = 'UPDATE_ALERT_SUCCESS';
export const DELETE_ALERT_SUCCESS = 'DELETE_ALERT_SUCCESS';
export const UPDATE_ALERTS_CURRENT_PAGE = 'UPDATE_ALERTS_CURRENT_PAGE';
export const UPDATE_ALERTS_TOTAL_PAGES = 'UPDATE_ALERTS_TOTAL_PAGES';
export const UPDATE_ALERTS_TOTAL_COUNT = 'UPDATE_ALERTS_TOTAL_COUNT';


// WEBPACK FOOTER //
// ./src/features/alertsManager/actionTypes.js